import ApiPlayers from '@/api/apiPlayers'
import Vue from 'vue'
import router from '../router'
import Player from '@/models/player'
import { createActionHelpers } from 'vuex-loading'

const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading'
})

const state = {
    players: [],
    player: new Player(),
    officialInfo: null
}

const actions = {
    loadPlayers(context) {
        startLoading(context.dispatch, 'loading players')
        ApiPlayers.all((players) => {
            context.commit('updatePlayers', players)
            endLoading(context.dispatch, 'loading players')
        }, error => {
            console.log('Error', error)
            endLoading(context.dispatch, 'loading players')
        })
    },
    create(context, player) {
        startLoading(context.dispatch, 'creating player')
        ApiPlayers.create(player, (response) => {
            endLoading(context.dispatch, 'creating player')
            console.log(response)
        }, error => {
            endLoading(context.dispatch, 'creating player')
            console.log('Error', error)
        })
    },
    update(context, player) {
        startLoading(context.dispatch, 'updating player')
        ApiPlayers.update(player.playerID, player.player, response => {
            endLoading(context.dispatch, 'updating player')
            console.log(response)
        }, error => {
            endLoading(context.dispatch, 'updating player')
            console.log('Error', error)
        })
    },
    find(context, playerID) {
        startLoading(context.dispatch, 'load player')
        ApiPlayers.find(playerID, (response) => {
            endLoading(context.dispatch, 'load player')
            context.commit('updatePlayer', response)
        }, error => {
            endLoading(context.dispatch, 'load player')
            console.log('Error', error)
        })
    },
    loadOfficialInfo(context,playerId){
      startLoading(context.dispatch, 'load player info')
      ApiPlayers.officialInfo(playerId, (response) => {
          endLoading(context.dispatch, 'load player info')
          context.commit('updateOfficialInfo', response.data.data)
      }, error => {
          endLoading(context.dispatch, 'load player info')
          console.log('Error', error)
      })
    }
}

const mutations = {
    updatePlayers(state, players) {
        state.players = players
    },
    updatePlayer(state, player) {
        state.player = player
    },
    updateOfficialInfo(state,data){
      state.officialInfo = data
    }
}

const getters = {
    currentPlayers(state) {
        return state.players
    },
    currentPlayerB(state) {
        return state.player
    },
    currentPlayerOfficialInfo(state){
      return state.officialInfo
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}



// WEBPACK FOOTER //
// ./src/store/players.js